import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Settings, LogOut } from 'lucide-react';
import { useAuth } from '../dataContext/AuthContext';
import { useLogout } from '../hooks/useLogout';
function ProfileDropdown({ isOpen, onClose }) {
    const navigate = useNavigate();
    const { emailAddress, firstName, lastName } = useAuth();
    const handleLogout = useLogout();
    const handleNavigateToProfilePage = () => {
        onClose?.();
        navigate("/profile");
    }
    return (
        <div className={`absolute right-0 top-12 w-48 bg-white rounded-lg shadow-lg py-2 border border-gray-200 z-50 ${isOpen ? 'block' : 'hidden'}`}>
            <div className="px-4 py-2 border-b border-gray-200">
                <p className="text-sm font-medium text-gray-900">{firstName} {lastName}</p>
                <p className="text-xs text-gray-500">{emailAddress}</p>
            </div>

            <button
                onClick={() => handleNavigateToProfilePage()}
                className="w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"
            >
                <Settings className="h-4 w-4 mr-2" />
                Manage Profile
            </button>

            <button
                className="w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"
                onClick={() => handleLogout()}
            >
                <LogOut className="h-4 w-4 mr-2" />
                Sign Out
            </button>
        </div>
    );
}

export default ProfileDropdown;